import { Controller } from "@hotwired/stimulus"

// Click-anywhere-in-this-wrapper-to-pick-a-file, preview immediately.
// Used for both the logo and signature uploads on the company profile
// form. The preview starts as a plain <i> placeholder icon when nothing's
// attached yet -- selecting a file swaps it for a live <img> (a plain src
// update if a real image is already showing, e.g. re-uploading over an
// existing logo/signature).
export default class extends Controller {
  static targets = ["input", "preview"]

  open() {
    this.inputTarget.click()
  }

  change() {
    const file = this.inputTarget.files[0]
    if (!file) return

    const reader = new FileReader()
    reader.onload = (event) => {
      let preview = this.previewTarget
      if (preview.tagName.toLowerCase() === "i") {
        const img = document.createElement("img")
        img.id = preview.id
        img.className = "logo-thumbnail"
        img.setAttribute("data-image-upload-target", "preview")
        img.src = event.target.result
        preview.replaceWith(img)
        preview = img
      } else {
        preview.src = event.target.result
      }

      const floatingLabel = this.element.closest(".floating-label")
      if (floatingLabel) floatingLabel.classList.add("filled")
    }
    reader.readAsDataURL(file)
  }
}
